import ModalComponent from "@zenith/components/ui/ModalComponent/modal-component/modal-component";
import {
  CONNECTION_MODAL_BODY,
  CONNECTION_MODAL_TITLE,
} from "@zenith/data/constants";
import { memo, useEffect, useState } from "react";

const InternetConnectionComponent = memo(
  function InternetConnectionComponent() {
    // Online state
    const [isOnline, setIsOnline] = useState(navigator.onLine);

    /**
     * @function closeModal
     * @description Set online status to true and wait 2 seconds to check the connection again
     */
    const closeModal = () => {
      setIsOnline(true);
      setTimeout(() => {
        setIsOnline(navigator.onLine);
      }, 2000);
    };

    useEffect(() => {
      const handleConnection = () => {
        setIsOnline(navigator.onLine);
      };

      // Add Listener when there's connection
      window.addEventListener("online", handleConnection);

      // Add Listener when there's no connection
      window.addEventListener("offline", handleConnection);

      // Remove listeners after effect
      return () => {
        window.removeEventListener("online", handleConnection);
        window.removeEventListener("offline", handleConnection);
      };
    }, [isOnline]);

    return (
      <ModalComponent
        title={CONNECTION_MODAL_TITLE}
        body={CONNECTION_MODAL_BODY}
        showModal={!isOnline}
        onClickButton={closeModal}
        onClickClose={closeModal}
        buttonText="Try again"
      />
    );
  }
);

export default InternetConnectionComponent;
